import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class CondicionPagoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    Get(rut_empresa, sucursal_codigo, callback) {
        const inputParams = this.createInputParams(rut_empresa, sucursal_codigo);
        this.executeQuery(inputParams, callback);
    }
    // FV: Lo hago a modo de limpiar la data de parámetros innecesarios y para direccionar la query en pro del contexto
    createInputParams(rut_empresa, sucursal_codigo) {
        return {
            rut_empresa,
            sucursal_codigo,
        };
    }
    executeQuery(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal) {
            condicion_pago {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo } }) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.condicion_pago.obtenerSegunFiltro;
            if (!respuesta) {
                callback(null);
                return;
            }
            const { registros } = respuesta;
            callback({ registros });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $tipobusqueda: Int) {
            condicion_pago {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: $tipobusqueda } }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    descripcion
                    cantidad_dias
                    uso_venta
                    uso_compra
                    estado
                    recargoporc
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.condicion_pago.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerCondicionPagoCompra(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: condicion_pagoInputType) {
            condicion_pago {
              obtenerCondicionPagoCompra(entidad: $entidad) {
                respuesta {
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    descripcion
                    cantidad_dias
                    estado
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.condicion_pago.obtenerCondicionPagoCompra;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunId(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: condicion_pagoInputType) {
            condicion_pago {
              obtenerSegunId(entidad: $entidad) {
                respuesta {
                  descripcion
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.condicion_pago.obtenerSegunId;
            callback({ mensajes, respuesta });
        });
    }
}
CondicionPagoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CondicionPagoService_Factory() { return new CondicionPagoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: CondicionPagoService, providedIn: "root" });
